import React from 'react';
import { CardBody, Row, Col, FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import SiteKeyBlock from './SiteKeyBlock';
import FBApiRequestsGuide from './FBApiRequestsGuide';
import { FMessage } from '../../hoc/IntlComponents';

const FBApiRequests = ({ type, tabProps: { api_key }, inProfile }) => (
  <CardBody>
    <SiteKeyBlock type={type} api_key={api_key} />
    {api_key && !inProfile && <FBApiRequestsGuide />}
    {api_key && inProfile && <Row className='upd-api-btn'>
      <Col>
        <FormGroup>
          <Link
            to={{
              pathname: "/tickets/create",
              search: "?sitekey=update_key",
            }}
            className="btn btn-primary btn-md outline"
          >
            <FMessage id='transfer-by-api.sitekey.update.btn' />
          </Link>
        </FormGroup>
      </Col>
    </Row>}
  </CardBody>
);

export default FBApiRequests;
